import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-applink-style1',
  templateUrl: './applink-style1.component.html',
  styleUrls: ['./applink-style1.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ApplinkStyle1Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/callouts/applink-style1/applink-style1.component.ts